module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("General Page"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("General Page")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Basic layout")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h4', [_vm._v("Basic usage")]), _vm._v(" "), _c('p', [_vm._v("Quickly and easily create layouts with the basic 24-column. Create basic grid layout using columns.")]), _vm._v(" "), _c('p', [_vm._v("With "), _c('code', [_vm._v("row")]), _vm._v(" and "), _c('code', [_vm._v("col")]), _vm._v(", we can easily manipulate the layout using the "), _c('code', [_vm._v("span")]), _vm._v(" attribute.")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-dark"
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  })])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  })])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Column Spacing")]), _vm._v(" "), _c('p', [_vm._v("Row provides "), _c('code', [_vm._v("gutter")]), _vm._v(" attribute to specify spacings between columns, and its default value is 0.")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Alert")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('h4', [_vm._v("Alert")]), _vm._v(" "), _c('p', [_vm._v("Alert components are non-overlay elements in the page that does not disappear automatically.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "success alert",
      "type": "success",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "info alert",
      "type": "info",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "warning alert",
      "type": "warning",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "error alert",
      "type": "error",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Customizable close button")]), _vm._v(" "), _c('p', [_vm._v("Customize the close button as texts or other symbols.")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "unclosable alert",
      "type": "success",
      "closable": false
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "customized close-text",
      "type": "info",
      "close-text": "Gotcha"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "alert with callback",
      "type": "warning"
    },
    on: {
      "close": _vm.hello
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("With icon and description")]), _vm._v(" "), _c('p', [_vm._v("Description includes a message with more detailed information.")]), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "success alert",
      "type": "success",
      "description": "more text description",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "info alert",
      "type": "info",
      "description": "more text description",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "warning alert",
      "type": "warning",
      "description": "more text description",
      "show-icon": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "error alert",
      "type": "error",
      "description": "more text description",
      "show-icon": ""
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Typography")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "remove",
      "data-toggle": "tooltip",
      "title": "Remove"
    }
  }, [_c('i', {
    staticClass: "ti-close"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": "20"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('h3', [_c('strong', [_vm._v("Heading")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('h1', [_vm._v("h1. This is a very large header.")]), _vm._v(" "), _c('h2', [_vm._v("h2. This is a large header.")]), _vm._v(" "), _c('h3', [_vm._v("h3. This is a medium header.")]), _vm._v(" "), _c('h4', [_vm._v("h4. This is a moderate header.")]), _vm._v(" "), _c('h5', [_vm._v("h5. This is a small header.")]), _vm._v(" "), _c('h6', [_vm._v("h6. This is a tiny header.")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": "20"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', [_c('strong', [_vm._v("Blockquote")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('blockquote', [_vm._v("Those people who think they know everything are a great annoyance to those of us who do. "), _c('cite', [_vm._v("Isaac Asimov")])])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": "20"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('p', [_c('strong', [_vm._v("Code")])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('code', [_vm._v("Those people who think they know everything are a great annoyance to those of us who do. ")])])], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32475080!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/ui/General.vue
// module id = 992
// module chunks = 2